"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("../Text"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HighlightText = ({
  text,
  highlight,
  size,
  semibold,
  ...restProps
}) => {
  if (!highlight || !highlight.trim()) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
    size: size,
    semibold: semibold,
    ...restProps,
    children: text
  });
  const regex = new RegExp(`(${highlight})`, 'gi');
  const parts = text.split(regex);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
    size: size,
    semibold: semibold,
    ...restProps,
    children: parts.filter(part => part).map((part, i) => regex.test(part) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Highlighted, {
      children: part
    }, i) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: part
    }, i))
  });
};
var _default = exports.default = HighlightText;